import React from 'react'
import AntDesignIcon from '@expo/vector-icons/AntDesign'
import { useMediaQueries, useTheme, useThemeClient } from '@/presentation/hooks'
import { HStack, Text, Button } from '@/presentation/components'

type PageHeaderProps = {
  text: string
  icon: React.ReactNode
  children?: React.ReactNode
  openFilters?: () => void
  disableFilters?: boolean
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  text,
  children,
  icon,
  openFilters,
  disableFilters
}) => {
  const theme = useTheme()
  const { isMobile } = useMediaQueries()
  const { getAccentColor } = useThemeClient()

  return (
    <HStack items='center' justify='between' mb={8}>
      <HStack items='center' spacing={8}>
        {icon}
        <Text color={theme.colors.grey} variant='subtitle1'>{text}</Text>
      </HStack>
      {children}
      {openFilters &&
        <Button
          title='Filtros'
          trailing={props => <AntDesignIcon name='filter' {...props} size={isMobile ? 14 : 18} />}
          color={getAccentColor()}
          disabled={disableFilters}
          onPress={openFilters}
          testID='button-filtros'
        />
      }
    </HStack>
  )
}
